import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-78" data-mp="sa9rfbp63pvl">
      <div className="h-1 w-full bg-electric" aria-hidden="true" data-id="element-79" data-mp="ncglmjrs0xvu" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-80" data-mp="neaw145f97lo">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-electric/50 bg-panel px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-white" data-id="element-81" data-mp="3d2tp5bt8kofl">
          <ZapIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-82" data-mp="39b4fyxmj3o1c" /> {productShortName}
        </motion.p>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-83" data-mp="3e84mtar7cuti">
          <img src={productImage} alt="Electrical Engineering Teacher Ready: six volumes and five bonus resources covering fundamentals, circuits, electrical machines, power systems, installations and control, and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-84" data-mp="2qkda461r2frp" />
        </motion.div>

        <div className="mt-9" data-id="element-85" data-mp="2lla68oxiaflb">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-86" data-mp="2ljgyt7f2jrc9">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-87" data-mp="nbbdp0t5cf6c">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-electric/30 bg-panel px-3 py-2" data-id="element-88" data-mp="ichwaxaqo40w">
              <Icon className="h-3.5 w-3.5 text-electric" aria-hidden="true" data-id="element-89" data-mp="1b0vupe5qp2cz" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}